export class ActivatePayload {
  email?: string;
  mobile?: string;
  code?: string;
  resend?: boolean;

  constructor() {
    this.email = '';
    this.mobile = '';
    this.code = '';
    this.resend = false;
  }
}

export class RegisterPayload {
  name: string;
  email: string;
  mobile: string;
  country: string;
  password: string;
  password_confirmation: string;

  constructor() {
    this.name = '';
    this.email = '';
    this.mobile = '';
    this.country = '';
    this.password = '';
    this.password_confirmation = '';
  }
}

export class ResetPayload {
  mobile: string;
  token: string;
  password: string;
  password_confirmation: string;

  constructor() {
    this.mobile = '';
    this.token = '';
    this.password = '';
    this.password_confirmation = '';
  }
}
